module.exports = __webpack_public_path__ + "img/Einzeldiagnose_Rechnung_Taifun_B.a1688fcf.png";